import React from "react";
import Loader from "../../Loader";
import { formStyles } from "../formStyles";

export default function CreateProfileStep(props) {
  const { register, errors, inputs, handleChange, onVerify, isVerifying, setStep } = props;

  return (
    <div className={formStyles.card}>
      <h2 className={formStyles.header}>Create User Profile</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className={formStyles.label}>Profile Type <span className="text-red-500">*</span></label>
          <div className="flex gap-4 mt-2" onChange={handleChange}>
            <label className="flex items-center bg-gray-50 border border-gray-200 px-4 py-3 rounded-lg cursor-pointer hover:bg-gray-100 w-full">
              <input type="radio" name="r_profile_type" value="individual" required className="w-4 h-4 text-blue-600" />
              <span className="ml-2 font-medium">Personal</span>
            </label>
            <label className="flex items-center text-slate-400 bg-gray-50 border border-gray-200 px-4 py-3 rounded-lg cursor-not-allowed w-full">
              <input type="radio" name="r_profile_type" value="corporate" disabled required className="w-4 h-4" />
              <span className="ml-2 font-medium">Organization</span>
            </label>
          </div>
        </div>
        <div>
          <label className={formStyles.label}>Identification Type <span className="text-red-500">*</span></label>
          <select name="r_id_type" {...register("r_id_type", { required: true })} onChange={handleChange} className={formStyles.input}>
            <option value="">Select ID Type</option>
            {inputs.r_profile_type === "corporate" && <option value="cac">Corporate Affairs Commission</option>}
            {inputs.r_profile_type === "corporate" && <option value="tin">Tax Identification Number</option>}
            {inputs.r_profile_type === "individual" && <option value="nin">National Identification Number (NIN)</option>}
          </select>
        </div>
        <div>
          <label className={formStyles.label}>Identification Number <span className="text-red-500">*</span></label>
          <input name="r_id_number" type="text" {...register("r_id_number", { required: true })} onChange={handleChange} className={formStyles.input} placeholder="Enter ID Number" />
        </div>
        {inputs.r_id_type === "dl" && (
          <div>
            <label className={formStyles.label}>Phone Number <span className="text-red-500">*</span></label>
            <input name="r_phone" type="text" {...register("r_phone", { required: true })} onChange={handleChange} className={formStyles.input} />
            {errors.r_phone && <p className="text-sm text-red-500 mt-1">Phone is required</p>}
          </div>
        )}
      </div>
      <div className="pt-6 mt-8 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-slate-600">
          Already registered? <button type="button" onClick={() => setStep(0)} className="font-bold text-blue-600 hover:underline">Login here</button>
        </p>
        <button onClick={onVerify} className={formStyles.buttonPrimary}>
          Verify Identity {isVerifying && <span className="ml-2"><Loader /></span>}
        </button>
      </div>
    </div>
  );
}